<vwui-header>
  <h2 a11yPageTitleLevel="1">{{ "PAGE_TASK_LIBRARY.title" | translate}}</h2>
</vwui-header>

@if (loadingSpinnerService.isSpinnerVisible()) {
  <vwui-spinner></vwui-spinner>
}

@if (!loadingSpinnerService.isSpinnerVisible()) {
  <div class="mt-lg">
    <app-library-mgmt [library]="tasksLibrary" [companyTypeId]="companyTypeId">
    </app-library-mgmt>
  </div>
}
